import { useSelector } from "react-redux";
import { SEO } from "utils/helmet/components/SEO";
import url from "url/index";
import HomePage from "components/pages/Casino/Home";
import {
  CATEGORIES_LIVE,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";
import * as gameSelector from "redux/game/selectors";
import { useMemo } from "react";
import { useGetCategoriesList } from "../../queries/useGetCategoriesList";
import { useBreakpoint } from "../../hooks/useBreakpoint";

const HomePageContainer = () => {
  const category = useSelector(gameSelector.category);
  const { isDesktop } = useBreakpoint();

  const { categories } = useGetCategoriesList("mainPage", isDesktop ? 1 : 2);
  const currentCategory = useMemo(() => {
    if (category && categories) {
      return (
        [...POPULAR_CATEGORIES, ...categories, ...CATEGORIES_LIVE].find(
          (cat) => cat.name === category,
        ) || null
      );
    }
    return null;
  }, [category, categories]);
  return (
    <>
      <SEO pathname={url.routes.casino.index()} />
      <HomePage category={currentCategory} />
    </>
  );
};

export default HomePageContainer;
